import { Grid, Step, StepConnector, StepLabel, Stepper, withStyles } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { QuitButton } from "components/Back";
import CancellationDialog from "components/CancelDialog/DialogCancellation";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { HeaderContainer, TitleContainer } from "domains/Request/component/shared/MainStyles";
import Airbills from "domains/Task/components/Job/Airbills";
import { Parcel } from "generated/graphql";
import { useCurrentUser } from "hooks";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NewJobContext } from "../context";
import NewJobInfos from "./JobInfos";
import { JobReacap } from "./JobReacp";
import { OrdersList } from "./OderList";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      padding: "24px",
      height: "90vh",
      [theme.breakpoints.down("xs")]: { background: "#fafcfe", margin: -27, height: "auto" },
    },
    top: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        width: "110vw",
        marginRight: -4,
        marginLeft: -8,
      },
    },
    title: {
      textAlign: "left",
      fontSize: 24,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#1a224b",
    },
    bottom: {
      flexDirection: "column",
      display: "flex",
      justifyContent: "center",
      flex: 5,
      [theme.breakpoints.down("xs")]: {
        marginLeft: -9,
      },
    },
    form: {
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: -7,
        borderRaduis: "4px",
        background: COLORS.white,
      },
    },
    userName: {
      textAlign: "left",
      fontSize: "24px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      padding: "10px",
      color: "#757a93",
      [theme.breakpoints.down("xs")]: { fontSize: "10px", marginLeft: -12, marginTop: "14px" },
    },
    createJob: {
      [theme.breakpoints.down("xs")]: {
        marginBottom: "6px",
        marginTop: -15,
        marginLeft: 10,
      },
    },
    step: {
      backgroundColor: "transparent",
      marginBottom: 20,
      marginTop: -27,
      [theme.breakpoints.down("xs")]: {
        width: "123vw",
        position: "relative",
        paddingTop: "34px",
        right: "54px",
      },
    },
    currentUser: {
      color: "rgb(59, 204, 246)",
      [theme.breakpoints.down("xs")]: { fontSize: "10px" },
    },
    quitButton: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "17px",
      },
    },
    labelStepJob: {
      [theme.breakpoints.down("xs")]: {
        "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
          marginTop: "16px",
          fontSize: "12px",
        },
      },
    },
  })
);
export const ColorlibConnector = withStyles({
  active: {
    "& $line": {
      backgroundColor: "#399ebf",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: "#399ebf",
    },
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useParcelSteps = () => {
  const { text } = useText();
  return [`${text.parcel.pickup_dropoff_tab}`, `${text.all.client}`, `${text.all.recap}`];
};
export function NewJobCreation() {
  const styles = useStyles();
  const { userData, setOrders, setUserData, setTuck } = React.useContext(NewJobContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { text } = useText();
  const steps = useParcelSteps();
  const navigation = useNavigate();
  const [parcels, setParcels] = React.useState<Array<Parcel>>(null);
  const currentUser = useCurrentUser();

  React.useEffect(() => {
    if (currentUser) {
      setUserData(currentUser?.user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const ViewStep = React.useCallback(() => {
    switch (activeStep) {
      case 0:
        return <NewJobInfos onNext={setActiveStep} />;
      case 1:
        return <OrdersList onNext={setActiveStep} cancelUpdate={() => setOpenDialog(true)} />;
      case 2:
        return <JobReacap activeStep={activeStep} setActiveStep={setActiveStep} setParcels={setParcels} />;
      case 3:
        return <Airbills setActiveStep={setActiveStep} parcels={parcels} />;
      default:
        return <NewJobInfos onNext={setActiveStep} />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  useEffect(() => {
    if(activeStep === 2){
      setTuck(true);
    }
  }, [activeStep]);

  const onConfirmCancel = () => {
    setOrders([]);
    navigation("/");
  };

  const handleQuit = () => {
    setOpenDialog(true);
  };
  const handleCloseModal = () => {
    setOpenDialog(false);
  };

  return (
    <div className={styles.root}>
      <Grid container spacing={4}>
        <div className={styles.top}>
          <Grid item xs={12} spacing={2} className={styles.createJob}>
            <HeaderContainer>
              <QuitButton onClick={handleQuit} className={styles.quitButton} />
              <span className={styles.userName}>{text.all.new_parcels} :</span>{" "}
              <TitleContainer>
                <span className={styles.currentUser}>
                  {currentUser?.user?.company_user_firstname} {currentUser?.user?.company_user_lastname}
                </span>{" "}
              </TitleContainer>
            </HeaderContainer>

            <Grid item xs={12}>
              <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
                style={{
                  backgroundColor: "transparent",
                }}
                className={styles.step}
              >
                {steps.map((label, index) => (
                  <Step
                    className={clsx({
                      activeStep: activeStep === index,
                    })}
                    key={label}
                  >
                    <StepLabel className={styles.labelStepJob}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container spacing={4}>
        <div className={styles.bottom}>
          <div className={styles.form}>
            <ViewStep />
          </div>
        </div>
      </Grid>
      <CancellationDialog
        title={text.all.cancel_new_parcels}
        message={text.all.cancel_new_parcels_message}
        open={openDialog}
        onClose={handleCloseModal}
        onConfirm={onConfirmCancel}
      />
    </div>
  );
}
